/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum PermissionDisplayType {
  ANONYMOUS = "ANONYMOUS",
  GROUP = "GROUP",
  GUEST_USER = "GUEST_USER",
  LICENSED_USER = "LICENSED_USER",
}
export enum SpacePermissionType {
  ADMINISTER_SPACE = "ADMINISTER_SPACE",
  ARCHIVE_PAGE = "ARCHIVE_PAGE",
  ARCHIVE_SPACE = "ARCHIVE_SPACE",
  COMMENT = "COMMENT",
  CREATE_ATTACHMENT = "CREATE_ATTACHMENT",
  CREATE_BLOG = "CREATE_BLOG",
  CREATE_EDIT_PAGE = "CREATE_EDIT_PAGE",
  DELETE_SPACE = "DELETE_SPACE",
  EDIT_BLOG = "EDIT_BLOG",
  EDIT_NATIVE_CONTENT = "EDIT_NATIVE_CONTENT",
  EXPORT_CONTENT = "EXPORT_CONTENT",
  EXPORT_PAGE = "EXPORT_PAGE",
  EXPORT_SPACE = "EXPORT_SPACE",
  MANAGE_GUEST_USERS = "MANAGE_GUEST_USERS",
  MANAGE_NONLICENSED_USERS = "MANAGE_NONLICENSED_USERS",
  MANAGE_PUBLIC_LINKS = "MANAGE_PUBLIC_LINKS",
  MANAGE_USERS = "MANAGE_USERS",
  REMOVE_ATTACHMENT = "REMOVE_ATTACHMENT",
  REMOVE_BLOG = "REMOVE_BLOG",
  REMOVE_COMMENT = "REMOVE_COMMENT",
  REMOVE_MAIL = "REMOVE_MAIL",
  REMOVE_OWN_CONTENT = "REMOVE_OWN_CONTENT",
  REMOVE_PAGE = "REMOVE_PAGE",
  SET_PAGE_PERMISSIONS = "SET_PAGE_PERMISSIONS",
  VIEW_SPACE = "VIEW_SPACE",
}
export interface SubjectPermissionDeltas {
  permissionsToAdd: Array<InputMaybe<SpacePermissionType>>;
  permissionsToRemove: Array<InputMaybe<SpacePermissionType>>;
  subjectKeyInput: UpdatePermissionSubjectKeyInput;
}
export interface UpdatePermissionSubjectKeyInput {
  permissionDisplayType: PermissionDisplayType;
  subjectId: Scalars["String"]["input"];
}
export type UpdateSpacePermissionsPrincipalsMutation_updateSpacePermissions_UpdateSpacePermissionsPayload_errors_MutationError =
  {
    __typename?: "MutationError";
    message: string | null;
  };
export type UpdateSpacePermissionsPrincipalsMutation_updateSpacePermissions_UpdateSpacePermissionsPayload =
  {
    __typename?: "UpdateSpacePermissionsPayload";
    success: boolean;
    spaceKey: string;
    errors: Array<UpdateSpacePermissionsPrincipalsMutation_updateSpacePermissions_UpdateSpacePermissionsPayload_errors_MutationError> | null;
  };
export type UpdateSpacePermissionsPrincipalsMutation_Mutation = {
  __typename?: "Mutation";
  updateSpacePermissions: UpdateSpacePermissionsPrincipalsMutation_updateSpacePermissions_UpdateSpacePermissionsPayload | null;
};
export type UpdateSpacePermissionsPrincipalsMutationVariables = Exact<{
  spaceKey: Scalars["String"]["input"];
  subjectPermissionDeltasList:
    | Array<SubjectPermissionDeltas>
    | SubjectPermissionDeltas;
}>;
export type UpdateSpacePermissionsPrincipalsMutation =
  UpdateSpacePermissionsPrincipalsMutation_Mutation;
